import { render } from "./LangSwitcher.vue?vue&type=template&id=b50b5648"
import script from "./LangSwitcher.vue?vue&type=script&lang=js"
export * from "./LangSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QBtnDropdown,QList,QItem,QItemSection,QItemLabel});qInstall(script, 'directives', {ClosePopup});
